import React from 'react';
import { QuickLinksIcon } from '@tanium/react-graphics';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from '@tanium/react-page';
import { Well } from '@tanium/react-well';
import { Stack } from '@tanium/react-stack';
import { Tile } from '@tanium/react-tile';
import { Link } from '@tanium/react-link';
import { DocLinks } from '../../utilities/constants';
import { useComplianceFramework } from '../../hooks/useComplianceFramework';
import { ComplianceFramework } from '../../types';

export const OtherServiceSection: React.VFC = () => {
  const { t } = useTranslation();
  const complianceFramework = useComplianceFramework();

  const supportPortalUrl =
    complianceFramework === ComplianceFramework.USGov
      ? DocLinks.TANIUM_SUPPORT_PORTAL_USG
      : DocLinks.TANIUM_SUPPORT_PORTAL;

  const links: { name: string; urlPath: string }[] = [
    { name: t('Tanium Resource Center'), urlPath: DocLinks.TANIUM_RESOURCE_CENTER },
    { name: t('Tanium Trust Center (TRC)'), urlPath: DocLinks.TANIUM_TRUST_CENTER },
    { name: t('Tanium Support Portal'), urlPath: supportPortalUrl },
    { name: t('Tanium Titans Community'), urlPath: DocLinks.TANIUM_TITANS_COMMUNITY },
    { name: t('Tanium Partner Portal'), urlPath: DocLinks.TANIUM_PARTNERS },
    { name: t('Developer Portal'), urlPath: DocLinks.TANIUM_DEVELOPER },
    { name: t('Tanium Training (LMS)'), urlPath: DocLinks.TANIUM_TRAINING },
    { name: t('Tanium Legal'), urlPath: DocLinks.TANIUM_LEGAL },
  ];

  return (
    <Page header={<PageHeader icon={QuickLinksIcon} heading={'Other Services'} />}>
      <Well p={1}>
        <Stack direction="column" itemSpacing={2}>
          {links.map(({ name, urlPath }) => (
            <Tile p={2} key={name}>
              <Link target="_blank" href={urlPath}>
                {name}
              </Link>
            </Tile>
          ))}
        </Stack>
      </Well>
    </Page>
  );
};
